module.exports = __webpack_public_path__ + "img/hs.2e72e9f2.png";